module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_AlignBottom_16"],"path":[{"$":{"d":"M6,2v9H3V2H6M7,1H2V12H7V1ZM0,13v2H16V13ZM9,4v8h5V4Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_AlignBottom_16.svg
// module id = fmJQ
// module chunks = 1